import { Tag1 } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";

import { swSettings } from "app/common/services/swSettings";
import { isAeoSolution } from "app/common/utils/isAeoSolution";
import { ANNUAL_THEME } from "app/components/discountCampaign/CampaignPromoModal/themePresets";
import type { ICampaignScenarioConfig } from "app/components/discountCampaign/campaignScenarioConfig.types";

const ANNUAL_BANNER_GRADIENT = `linear-gradient(34deg, ${colorsPalettes.blue[400]} 0%, ${colorsPalettes.blue[500]} 30.29%, ${colorsPalettes.midnight[400]} 70%, ${colorsPalettes.midnight[500]} 100%)`;

const CI_CAMPAIGN_DISCOUNT_PERCENTAGE = 37;
const AEO_CAMPAIGN_DISCOUNT_PERCENTAGE = 23;

export const ANNUAL_CAMPAIGN_CONFIG: Omit<ICampaignScenarioConfig, "discountConfig"> = {
    banner: {
        theme: {
            color: colorsPalettes.carbon[0],
            background: ANNUAL_BANNER_GRADIENT,
            counterColor: colorsPalettes.blue[500],
            ctaButtonColor: colorsPalettes.blue[500],
            showButton: true,
            showTimer: false,
            showCloseButton: true,
        },
        content: {
            icon: Tag1,
            iconSize: "sm",
            iconColor: colorsPalettes.blue[200],
            text: "discount.annual.promo.banner.text",
            percentage: isAeoSolution(swSettings) ? AEO_CAMPAIGN_DISCOUNT_PERCENTAGE : CI_CAMPAIGN_DISCOUNT_PERCENTAGE,
            trackingEventName: "Discount Banner/4 months upgrade",
        },
    },
    modal: {
        theme: ANNUAL_THEME,
        content: {
            title: "promo.annual.upgrade",
            buttonText: "discount.first_week.banner.button",
            percentageTranslationKey: "upgrade.to.annual.campaign.off",
            percentage: isAeoSolution(swSettings) ? AEO_CAMPAIGN_DISCOUNT_PERCENTAGE : CI_CAMPAIGN_DISCOUNT_PERCENTAGE,
            imageSrc: "data-credits-wallet.svg",
            imageSize: 179,
            isTimerHidden: true,
        },
    },
};
